import { supabase } from '../config/supabase';
import { CreateRegistroNovedadInput, CreateTipoNovedadInput } from '../types/novedad';

export const novedadService = {
  // Tipos de Novedad
  async createTipoNovedad({ nombre, descripcion }: CreateTipoNovedadInput) {
    const { data, error } = await supabase
      .from('tipo_novedad')
      .insert([{ nombre, descripcion }])
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async getTiposNovedad() {
    const { data, error } = await supabase
      .from('tipo_novedad')
      .select('*')
      .eq('activo', true)
      .order('nombre');

    if (error) throw error;
    return data;
  },

  async toggleActivo(id: string): Promise<any> {
    const { data, error } = await supabase
      .rpc('toggle_tipo_novedad_activo', { tipo_id: id });

    if (error) throw error;
    return data;
  },

  // Registros de Novedad
  async iniciarNovedad({ tipo_novedad_id, observacion }: CreateRegistroNovedadInput) {
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    if (userError) throw userError;
    if (!user) throw new Error('No hay usuario autenticado');

    const { data, error } = await supabase
      .from('registro_novedad')
      .insert([{
        empleado_id: user.id,
        tipo_novedad_id,
        observacion,
        estado: 'En curso'
      }])
      .select(`
        *,
        tipo_novedad (*)
      `)
      .single();

    if (error) throw error;
    return data;
  },

  async finalizarNovedad(registro_id: string) {
    const { data, error } = await supabase
      .from('registro_novedad')
      .update({
        fecha_hora_fin: new Date().toISOString(),
        estado: 'Finalizada'
      })
      .eq('id', registro_id)
      .select(`
        *,
        tipo_novedad (*)
      `)
      .single();

    if (error) throw error;
    return data;
  },

  async getNovedadesEmpleado(empleado_id: string) {
    const { data, error } = await supabase
      .from('registro_novedad')
      .select(`
        *,
        tipo_novedad (*)
      `)
      .eq('empleado_id', empleado_id)
      .order('fecha_hora_inicio', { ascending: false });

    if (error) throw error;
    return data;
  },

  async getNovedadesActivas(empleado_id: string) {
    const { data, error } = await supabase
      .from('registro_novedad')
      .select(`
        *,
        tipo_novedad (*)
      `)
      .eq('empleado_id', empleado_id)
      .eq('estado', 'En curso')
      .order('fecha_hora_inicio', { ascending: false });

    if (error) throw error;
    return data;
  }
};
